// Create browser history object for tracking browser state
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
export default browserHistory;
